import { createContext } from "react";

const ServerStyleContext = createContext(null);

export default ServerStyleContext;
